/* SARATTI LUX — scroll reveal engine. Tags lux section content for staggered
   entrance + slow image settle, then reveals each section on viewport entry. */
(function () {
  var d = document;
  function init() {
    d.documentElement.classList.add('lux-motion');
    var groups = [];
    function tag(container, els) {
      var i = 0;
      els.forEach(function (e) {
        if (!e) return;
        e.setAttribute('data-lux-reveal', '');
        e.style.setProperty('--lux-d', (i * 0.12) + 's');
        i++;
      });
      groups.push(container);
    }
    d.querySelectorAll('.lux-hero').forEach(function (s) {
      var c = s.querySelector('.lux-hero__content');
      if (c) tag(s, [].slice.call(c.children));
      var img = s.querySelector('.lux-hero__img');
      if (img) img.setAttribute('data-lux-zoom', '');
    });
    d.querySelectorAll('.lux-maison').forEach(function (s) {
      tag(s, [].slice.call(s.children));
    });
    d.querySelectorAll('.lux-feature').forEach(function (s) {
      var c = s.querySelector('.lux-feature__content');
      if (c) tag(s, [].slice.call(c.children));
      var img = s.querySelector('.lux-feature__img');
      if (img) img.setAttribute('data-lux-zoom', '');
    });
    d.querySelectorAll('.lux-duo').forEach(function (s) {
      [].slice.call(s.querySelectorAll('.lux-duo__panel')).forEach(function (p, i) {
        p.setAttribute('data-lux-reveal', '');
        p.style.setProperty('--lux-d', (i * 0.15) + 's');
        var im = p.querySelector('.lux-duo__img');
        if (im) im.setAttribute('data-lux-zoom', '');
      });
      groups.push(s);
    });
    d.querySelectorAll('.lux-bespoke').forEach(function (s) {
      var c = s.querySelector('.lux-bespoke__inner');
      if (c) tag(s, [].slice.call(c.children));
    });
    if (!('IntersectionObserver' in window)) {
      groups.forEach(function (g) { g.classList.add('lux-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('lux-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    groups.forEach(function (g) { io.observe(g); });
    d.querySelectorAll('.lux-hero').forEach(function (s) {
      requestAnimationFrame(function () {
        setTimeout(function () { s.classList.add('lux-in'); }, 80);
      });
    });
  }
  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }
})();
